exports.default = {
  'basic_info': 'Basic Information',
  'team_avatar': 'Team Avatar',
  'edit_avatar': 'Edit Avatar',
  'team_name': 'Team Name',
  'edit_team_name': 'Edit team name',
  'team_name_required': 'Please enter a team name',
  'team_description': 'Team Description',
  'save': 'Save',
  'save_success': 'Save successful!',
  'payment_info': 'Payment Information',
  'team_benefits': 'Team Benefits',
  'version_info': 'Version Information',
  'team_id': 'Team ID',
  'owner': 'Owner',
  'member_seats': 'Members / seats',
  'team_remaining_points': 'Team credits remaining',
  'member_count': '{count} members, deleted members and pending activation members do not count against quota',
  'creation_time': 'Creation Time',
  'creation_time_format': '{y}/{m}/{d}',
  'more_operations': 'More Operations',
  'join_approval': 'Join Approval',
  'join_approval_desc': 'When enabled, members need team admin or super admin approval to join the team',
  'transfer_team': 'Transfer Team',
  'transfer_team_desc': 'Each team has only 1 owner, after transfer you will become a regular member',
  'transfer': 'Transfer',
  'dissolve_team': 'Dissolve Team',
  'dissolve_team_desc': 'After dissolution, all content in the team will be permanently deleted and cannot be recovered, please be cautious',
  'dissolve': 'Dissolve',
  'crop_image': 'Crop Image',
  'crop_image_question': 'Do you need to crop the image?',
  'crop': 'Crop',
  'upload_without_crop': 'Upload without cropping',
  'upload_image': 'Upload Image',
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'team_transfer': 'Team Transfer',
  'user': 'User',
  'phone': 'Phone',
  'prompt': 'Prompt',
  'email': 'Email',
  'join_time': 'Join Time',
  'operation': 'Operation',
  'transfer_btn': 'Transfer',
  'image_type_error': 'Image type must be one of: .gif, jpeg, jpg, png, bmp',
  'dissolve_team_prompt': 'Once you dissolve the team, all agents, project documents, and department members will be permanently deleted. This is an irreversible operation, please proceed with caution!',
  'dissolve_team_title': 'Dissolve Team',
  'dissolve_team_input_placeholder': 'Please enter "DELETE" to confirm',
  'dissolve_team_input_error': 'Please enter "DELETE" to confirm',
  'transfer_team_confirm': 'After transferring the team, you will become a regular team member! Confirm transfer?',
  'transfer_team_confirm_title': 'Prompt',
  'member': 'Member',
  'department': 'Department',
  'leave_member': 'Former Member',
  'waiting_approval': 'Waiting Approval',
  'already_joined': 'Already Joined',
  'add_sub_department': 'Add Subdepartment',
  'edit': 'Edit',
  'move_up': 'Move Up',
  'move_down': 'Move Down',
  'delete': 'Delete',
  'search_name_phone_email': 'Name, Phone, Email',
  'create_department': 'Create Department',
  'mark_as_leaving': 'Mark as Leaving',
  'change_department': 'Change Department',
  'invite_members': 'Invite Members',
  'name': 'Name',
  'edit_department': 'Edit Department',
  'parent_department': 'Parent Department',
  'department_name': 'Department Name',
  'department_name_required': 'Please enter department name',
  'get_department_list_failed': 'Failed to get department list',
  'add_department_failed': 'Failed to add department',
  'edit_department_failed': 'Failed to edit department',
  'department_setting': 'Change Department',
  'team_invitation': 'Team Invitation',
  'confirm_remove_member': 'Confirm remove this member?',
  'tips': 'Tips',
  'executing': 'Executing...',
  'operation_success': 'Operation successful!',
  'select_departments_to_change': 'Please select members to change first',
  'protected_member_cannot_leave': 'The owner and current user cannot be marked as leaving',
  'contains_protected_member': 'The selection contains the owner or current user, who cannot be marked as leaving',
  'select_members_to_leave': 'Please select members to leave first',
  'select_members_to_operate': 'Please select members to operate on first',
  'restore': 'Restore',
  'clear': 'Clear',
  'previous_department': 'Previous department before leaving',
  'days_since_leaving': 'Days since leaving',
  'leaving_date': 'Leaving date',
  'confirm_restore': 'Confirm restore member?',
  'confirm_delete': 'Confirm delete?',
  'confirm_clear': 'Confirm clear?',
  'select_members_first': 'Please select data to operate on first',
  'confirm_restore_member': 'Confirm restore member?',
  'pass': 'Approve',
  'reject': 'Reject',
  'confirm_approve': 'Confirm approve joining the company?',
  'confirm_reject': 'Confirm reject joining the company?',
  'enter_department_name': 'Please enter department name',
  'batch_delete': 'Batch Delete',
  'batch_edit': 'Batch Edit',
  'department_members': 'Department Members',
  'department_member_count': 'Department Member Count',
  'department_manager': 'Department Manager',
  'confirm_delete_department': 'Confirm delete department?',
  'already_highest_level': 'Already at the highest level',
  'already_the_top_level': 'Already at the highest level',
  'leave_date': 'Leaving date',
  'department_has_members': 'A member exists in this department or one of its subdepartments, so it cannot be deleted',
  'already_top_level': 'Already at the highest level',
  'select_departments_first': 'Please select departments to delete first',
  'delete_child_first': 'Please delete all subdepartments first before deleting the department.',
  'select_departments_to_edit': 'Please select departments to edit first',
  'roles': 'Roles',
  'member_roles': 'Member Roles',
  'role_management': 'Role Management',
  'role_authorization': 'Role Authorization',
  'authorize_role': 'Authorize',
  'no_authorization_items': 'No team management capabilities available',
  'create_role': 'Create Role',
  'edit_role': 'Edit Role',
  'role_name': 'Role Name',
  'role_name_required': 'Enter a role name',
  'confirm_delete_role': 'Delete this role?',
  'member_roles_and_limits': 'Member Roles & Limits',
  'limit_management': 'Limit Management',
  'limit_management_desc': 'Set credit usage limits for team members',
  'limit_status': 'Limit status',
  'limit_enabled': 'Enabled',
  'limit_disabled': 'Unlimited',
  'authorized_limit': 'Authorized limit',
  'remaining_limit': 'Remaining limit',
  'assign_roles': 'Assign Roles',
  'member_limit': 'Member Limit',
  'set_member_limit': 'Set Limit',
  'unlimited': 'Unlimited',
  'enable_member_limit': 'Enable member credit limit',
  'limit_adjustment': 'Limit adjustment',
  'current_authorized': 'Current authorized total',
  'after_adjustment': 'Authorized total after adjustment',
  'adjust_member_limit': 'Adjust Limit',
  'limit_adjustment_description': 'Choose an action and enter the number of credits',
  'limit_adjustment_mode': 'Mode',
  'limit_adjustment_add': 'Add',
  'limit_adjustment_reduce': 'Reduce',
  'limit_adjustment_points': 'Amount (credits)',
  'used_points': 'Credits used',
  'remaining_after_adjustment': 'Remaining limit after adjustment',
  'limit_reduction_max': 'You can reduce up to {max} credits. Only unused credits can be removed.',
  'invalid_points_amount': 'Enter a valid non-negative whole number of credits',
  'remaining_limit_nonnegative': 'The remaining limit cannot be below 0. Add credits before confirming.',
  'enable_limit_base_hint': 'When enabling the limit, credits used become the authorized base. Added credits become available to use.',
  'consumption_records': 'Consumption Records',
  'points_ledger_desc': 'View points earned, consumed, expired, and adjusted in this team',
  'points_event': 'Points Event',
  'occurred_at': 'Occurred At',
  'points_change': 'Points Change',
  'points_balance': 'Remaining Points',
  'points_earned': 'Points Earned',
  'points_expired': 'Points Expired',
  'points_adjusted': 'Points Adjusted',
  'points_consumption': 'Points Consumption',
  'agent_task': 'Agent Task',
  'expand_details': 'Expand Details',
  'collapse_details': 'Collapse Details',
  'no_points_records': 'No points ledger records',
  'load_points_records_failed': 'Failed to load the points ledger',
  'all_team_records': 'All Team Records',
  'my_team_records': 'My Records',
  'unknown_member': 'Unknown member'
}
